module.exports = __webpack_public_path__ + "static/media/banner-3.78f841c2.jpg";